export const selectTemplates = (state) => state.templates.templates;
export const selectTemplatesPag = (state) => state.templates.templatesPag;
export const selectTemplateTypes = (state)=> state.templates.templateTypes;

export const selectTemplatesLoading = (state) => state.templates.loading;
export const selectTemplatesError = (state) => state.templates.error;

export const selectEmailRecipients = (state) => state.templates.emailRecipients;
